<template>
  <div class="contest_banner_container"
  :class="[banner_type, $mq]"
  >
    <div class="contest_banner_cover"></div>
    <div class="contest_banner">
      <div class="container">
        <div class="row" :class="banner_type">
          <div class="col-2">
            <span class="contest_category_icon"
            v-if="icon"
            >
              <font-awesome-icon :icon="icon"></font-awesome-icon>
            </span>
          </div>
          <div class="col-8">
            <div class="contestant_name">{{ label }}</div>
          </div>
          <div class="col-2">
            <div class="contest_expanded_icon">
              <font-awesome-icon icon="caret-right" v-if="!is_expanded"></font-awesome-icon>
              <font-awesome-icon icon="caret-down" v-else="is_expanded"></font-awesome-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- CONTEST IMAGE -->
    <div class="contest_image" 
    :style="{backgroundImage: 'url(\'' + resize_cms_image(contest.lead_image) +  '\')'}"
    v-if="is_expanded && banner_type == 'contest' && contest.lead_image"
    ></div>
    
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faUtensils, 
  faShoppingCart, 
  faSmileBeam,
  faTaxi,
  faUsers,
  faBowlingBall,
  faFilm,
  faShoppingBasket,
  faSwimmer,
  faMapMarkedAlt,
  faCaretRight,
  faCaretDown,
  faCocktail
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faUtensils, 
  faShoppingCart, 
  faSmileBeam,
  faTaxi,
  faUsers,
  faBowlingBall,
  faFilm,
  faShoppingBasket,
  faSwimmer,
  faMapMarkedAlt,
  faCaretRight,
  faCaretDown,
  faCocktail
);

export default {
  name: 'ContestBanner',
  props: [
    'contest',
    'label',
    'icon',
    'lead_image',
    'banner_type',
    'is_expanded'
  ],
  data () {
    return {
      
    }
  },
  methods: {
    resize_cms_image: function(value) {
      if(value.indexOf('/rw/') > 0) {
        return value.replace(/\/rw\//g, '/rf/image_md/');
      }
      else {
        return value;
      }
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

$contest_banner_min_height: 72px;

.contest_banner_cover {
  position: absolute;
  width: 100%;
  min-height: $contest_banner_min_height;
  background: transparent;
  z-index: 100;
  cursor: pointer;
}

.contest_banner_container {
  position: relative;
  font-size: 1.4rem;
  border-bottom: solid 1px #aaa;

  &.supercat {
    border-bottom: solid 1px #ccc;
  }

  .row {
    background: $dcom-purple;
    color: #FFF;
    padding: 1.2rem 0;
  }

  .row.contest {
    background: $dcom-purple;
  }

  .row.supercat {
    background: $dcom-teal;
  }

  .contest_category_icon {
    display: block;
    text-align: center;
  }

  .contest_banner {
    min-height: $contest_banner_min_height;
  }

  .contest_image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .contest_expanded_icon {
    text-align: center;
  }

  &.desktop, &.laptop {
    .contest_image {
      height: 250px;
    }
    
  }

}


</style>


// WEBPACK FOOTER //
// src/features/contests/contest_banner.vue